<template>
  <div class="timeline-prof">
    <v-timeline>
      <v-timeline-item
        v-for="(event, i) in events"
        :key="i"
        :color="event.color"
        small
      >
        <span
          slot="opposite"
          :class="`headline font-weight-bold`"
          :style="{'color': event.color, 'font-size': '20px!important'}"
          v-text="event.date"
        ></span>
        <div class="py-3">
          <h3 :class="`font-weight-bold`" :style="{'color': event.color, 'text-align': ((i % 2 ===0)? 'center' : 'left')}">{{ event.text }}</h3>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  name: 'TimeLineProfessor',
  props: {
    events: Array,
  },
}
</script>

<style lang="scss">
.timeline-prof {
  padding: 5px;
}
</style>
